import Crud from '../views/TipoTransporte/Crud'
import Entity from '../views/TipoTransporte/Add'

let routes = {
    path: '/tipo_transporte',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_transporte/add',
            name: 'NovoAcompanhante',
            component: Entity
        },
        {
            path: '/tipo_transporte/edit/:id?',
            name: 'EditarAcompanhante',
            component: Entity
        },
        {
            path: '/tipo_transporte',
            name: 'list-tipo-transporte',
            component: Crud,
            meta: {
                pageTitle: 'Tipos',
                breadcrumb: [
                    {
                        text: 'Tipos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
